import styled from 'styled-components';
import heroBackground from '../../../assets/images/hero-background.png';
import heroBackgroundMb from '../../../assets/images/hero-background-mb.png';

export const HeroContainer = styled.div`
  min-height: 100vh;
  width: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.33), rgba(77, 77, 77, 0.06)), url(${heroBackground});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 12vh 0 8vh 0;
  
  @media (max-width: 768px) {
    min-height: 100vh; 
    padding: 0; 
    align-items: flex-end; 
    background-attachment: scroll;
    background-image: linear-gradient(rgba(0, 0, 0, 0.33), rgba(77, 77, 77, 0.06)), url(${heroBackgroundMb});
  }
  
  @media (max-width: 480px) {
    min-height: 100vh;
    align-items: flex-end;
  }
`;

export const HeroContent = styled.div`
  max-width: 730px;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  text-align: center;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    padding: 0 1.5rem 8vh 1.5rem; 
    max-width: 100%;
    margin-top: 0; 
    margin-bottom: 0; 
  }
  
  @media (max-width: 480px) {
    padding: 0 1rem 6vh 1rem; 
  }
`;

export const HeroHighlight = styled.div`
  display: inline-block;
  padding: 0.5rem 1.5rem;
  border: 1px solid white;
  letter-spacing: 4px;
  font-weight: 400;
  margin-bottom: 2rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 50px;
    height: 2px;
    background-color: #0066FF;
  }
  
  @media (max-width: 768px) {
    padding: 0.4rem 1rem;
    letter-spacing: 2px;
    font-size: 0.9rem;
    margin-bottom: 1.5rem;
  }
`;

export const HeroTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  max-width: 850px;
  font-weight: 600; 

  @media (max-width: 768px) {
    font-size: 2.2rem; 
    margin-bottom: 1rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`;

export const HeroText = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  max-width: 780px;
  margin: 0 auto;
  text-align: center;
  opacity: 0.95; 
  
  @media (max-width: 768px) {
    font-size: 1rem; 
    line-height: 1.5;
    max-width: 100%;
    padding: 0;
  }
`;